import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import client from '../api/client'
import { useAuthStore } from '../store/authStore'
import Spinner from '../components/Spinner'

export default function Login() {
  const navigate = useNavigate()
  const location = useLocation()
  const setUser = useAuthStore((s) => s.setUser)
  const [form, setForm] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const registered = (location.state as any)?.registered

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { data } = await client.post('/auth/login', form)
      localStorage.setItem('access_token', data.access_token)
      localStorage.setItem('refresh_token', data.refresh_token)
      const { data: me } = await client.get('/users/me')
      setUser(me)
      navigate('/dashboard')
    } catch (err: any) {
      setError(err.response?.data?.detail || '이메일 또는 비밀번호를 확인해주세요.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)] px-4 py-8">
      <div className="w-full max-w-sm bg-[var(--color-surface)] rounded-2xl p-6 sm:p-8 shadow-xl border border-[var(--color-border-default)]">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <p className="text-4xl mb-2">🏪</p>
            <h1 className="text-2xl font-bold text-[var(--color-accent)] hover:opacity-80 transition-opacity">운명편의점</h1>
          </Link>
          <p className="text-[var(--color-text-tertiary)] text-sm mt-1">어서오세요, 단골 손님 🏪</p>
        </div>

        {registered && (
          <div className="bg-[var(--color-success)]/10 border border-[var(--color-success)]/30 rounded-xl px-4 py-2.5 text-[var(--color-success)] text-sm mb-4">
            단골 손님 등록 완료! 🏪 로그인해주세요.
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-[var(--color-text-secondary)] mb-1">이메일</label>
            <input
              type="email" value={form.email} required autoComplete="email"
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-[var(--color-bg)] border border-[var(--color-border-default)] rounded-lg px-4 py-2.5 text-[var(--color-text-primary)] placeholder-[var(--color-text-disabled)] focus:outline-none focus:border-[var(--color-border-accent)] transition-colors"
            />
          </div>
          <div>
            <label className="block text-sm text-[var(--color-text-secondary)] mb-1">비밀번호</label>
            <input
              type="password" value={form.password} required autoComplete="current-password"
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-[var(--color-bg)] border border-[var(--color-border-default)] rounded-lg px-4 py-2.5 text-[var(--color-text-primary)] placeholder-[var(--color-text-disabled)] focus:outline-none focus:border-[var(--color-border-accent)] transition-colors"
            />
          </div>

          {error && (
            <div className="bg-[var(--color-error)]/10 border border-[var(--color-error)]/30 rounded-xl px-4 py-2.5 text-[var(--color-error)] text-sm">{error}</div>
          )}

          <button type="submit" disabled={loading}
            className="w-full bg-[var(--color-accent)] hover:opacity-90 disabled:opacity-60 text-[var(--color-primary)] rounded-lg py-2.5 font-bold transition-opacity flex items-center justify-center gap-2">
            {loading ? <><Spinner size="sm" /> 로그인 중...</> : '입장하기'}
          </button>
        </form>

        <p className="text-center text-[var(--color-text-tertiary)] text-sm mt-6">
          아직 회원이 아니신가요?{' '}
          <Link to="/register" className="text-[var(--color-accent)] hover:underline">회원가입</Link>
        </p>
        <p className="text-center text-[var(--color-text-disabled)] text-sm mt-3">
          <Link to="/" className="hover:text-[var(--color-text-secondary)] transition-colors">← 메인으로 돌아가기</Link>
        </p>
      </div>
    </div>
  )
}
